import React , { useState } from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import item from '../../assets/fake-data/item';

const SliderOne = () => {

    const [datatext] = useState({
        subtitle: 'Capture Create Connect',
        title: 'KOCHFOTO',
        desc: 'Technical mastery meets creative vision to deliver content that does not just inform it, inspires. With visual storytelling, every project becomes an experience that connects ideas and moves audiences to action.'
    })

    return (
        <section className="tf-section hero-slider">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-md-6 col-12">
                        <div className="block-text pt-24" >
                            <h6 className="sub-title mb-6" data-aos="fade-up">{datatext.subtitle}</h6>
                            <h2 className="title mb-26" data-aos="fade-up">{datatext.title}</h2>
                            <p className="desc mb-43" data-aos="fade-up">{datatext.desc}</p>
                            <a href="https://photo.kochfoto.com/" target="_blank" rel="noopener noreferrer" className="btn-action style-2" data-aos="fade-up" data-aos-duration="1200" >Client Work</a>
                        </div>
                    </div>
                    <div className="col-xl-7 col-md-6 col-12">
                        <div className="content-right d-flex">
                        <Swiper
                                modules={[ Autoplay ]}
                                direction={"vertical"}
                                spaceBetween={30}
                                slidesPerView={3}
                                loop
                                autoplay={{
                                    delay: 1,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                speed= {2000}
                            >
                                <SwiperSlide><div className="item bg-1"><img src={item.item1} alt="Professional headshot studio photography portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item31} alt="Professional headshot studio photography portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-1"><img src={item.item30} alt="Professional headshot studio photography portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item36} alt="Architectural photography professional portfolio showcase" /></div></SwiperSlide>

                            </Swiper>
                            <Swiper
                                modules={[ Autoplay ]}
                                direction={"vertical"}
                                spaceBetween={30}
                                slidesPerView={3}
                                loop
                                autoplay={{
                                    delay: 1,
                                    reverseDirection: true,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                speed= {2000}
                            >
                                <SwiperSlide><div className="item bg-2"><img src={item.item4} alt="Commercial photography professional portfolio work" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-1"><img src={item.item32} alt="Portrait photography professional portfolio sample" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item5} alt="Editorial photography professional portfolio showcase" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-1"><img src={item.item3} alt="Food photography professional portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item33} alt="Portrait photography professional portfolio sample" /></div></SwiperSlide>

                            </Swiper>
                            <Swiper
                                modules={[ Autoplay ]}
                                direction={"vertical"}
                                spaceBetween={30}
                                slidesPerView={3}
                                loop
                                autoplay={{
                                    delay: 1,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                speed= {2000}
                            >
                                <SwiperSlide><div className="item bg-2"><img src={item.item37} alt="Tabletop product photography portfolio showcase" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-1"><img src={item.item7} alt="Interior photography professional portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item35} alt="Editorial photography professional portfolio showcase" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-1"><img src={item.item6} alt="Interior photography professional portfolio example" /></div></SwiperSlide>
                                <SwiperSlide><div className="item bg-2"><img src={item.item34} alt="Portrait photography professional portfolio sample" /></div></SwiperSlide>

                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default SliderOne;